export default __webpack_public_path__ + "static/media/relationshipToWeak.bc95af92.jpg";